import React from 'react'

import { IncentivesDashboard } from './IncentivesDashboard'

const IncentivesLayout: React.FC = () => {
  return <IncentivesDashboard />
}

export default IncentivesLayout
